import React from 'react';
import { Navbar, Nav, Container, Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const OthersHeader = ({ logo, links }) => {
    return (
        <Navbar expand="lg" fixed="top" className="bg-white shadow-sm py-2">
            <Container>
                {/* Logo Section */}
                <Navbar.Brand as={Link} to="/">
                    <Image 
                        src={logo} 
                        alt="Project Logo" 
                        style={{ height: '55px', objectFit: 'contain' }} 
                    />
                </Navbar.Brand>

                {/* Mobile Toggle */}
                <Navbar.Toggle aria-controls="others-nav" className="border-0 shadow-none" />

                {/* Navigation Links */}
                <Navbar.Collapse id="others-nav">
                    <Nav className="ms-auto align-items-center">
                        {/* // Add a safety check: (links || []) */}
                        {(links || []).map((link, idx) => (
                            <Nav.Link 
                                key={idx} 
                                href={link.href} 
                                className="fw-bold px-3 text-dark"
                            >
                                {link.label}
                            </Nav.Link>
                        ))}
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default OthersHeader;